import overrideIfMinBetNumberEnabled from './MinBetNumberRegistrator'

overrideIfMinBetNumberEnabled(function () {

    (function (baseSlipSelection) {
        if (!baseSlipSelection) return;
    
        var _serialize = baseSlipSelection.prototype.serialize,
            _processBetUpdate = baseSlipSelection.prototype.processBetUpdate,
            _deserializeSelection = baseSlipSelection.deserializeSelection;

        $.extend(baseSlipSelection.prototype, {
            serialize: function () {
                return $.extend(_serialize.call(this), { MinBetNumber: this.MinBetNumber });
            },
            processBetUpdate: function (updates) {
                _processBetUpdate.call(this, updates);
                if (updates == -1) return;
                
                //if we got diff value for mbn => we should trigger update
                var triggerViewUpdate  = this.MinBetNumber && this.MinBetNumber !== updates.MinBetNumber;
                this.MinBetNumber = updates.MinBetNumber;
                
                if (triggerViewUpdate) {
                    BetSlip.CurrentMode.updateView()
                }
            }
        });

        $.extend(baseSlipSelection, {
            deserializeSelection: function (data) {
                var sel = _deserializeSelection.call(this, data);
                return sel ? $.extend(sel, { MinBetNumber: data.MinBetNumber }) : sel;
            }
        });
    })(window.BaseSlipSelection);

});